import React, { createElement, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import classNames from 'classnames';
import InputSubmit from './inputSubmit';
import InputText from './inputText';
import Select from './select';
import Checkbox from './checkbox';
import { numberYearMask, currencyMask, dateMask } from '../../shared/mask';

const Components = {
    input: InputText,
    select: Select,
    checkbox: Checkbox,
    submit: InputSubmit,
};

const FormBuilder = ({ fields, submitForm, idForm, className, bindValues, onfileChange, onHandleChange = null, title, ...props }) => {
    const [fileData, setFileData] = useState();
    const columns = {
        1: 'lg:col-span-1',
        2: 'lg:col-span-2',
        3: 'lg:col-span-3',
        4: 'lg:col-span-4',
        5: 'lg:col-span-5',
        6: 'lg:col-span-6',
        7: 'lg:col-span-7',
        8: 'lg:col-span-8',
        9: 'lg:col-span-9',
        10: 'lg:col-span-10',
        11: 'lg:col-span-11',
        12: '',
    };

    const initialValues = bindValues && Object.keys(bindValues).length > 0 ? fields.reduce((valuesObj, field) => ({ ...valuesObj, [field.name]: bindValues[field.name] }), {}) : fields.reduce((valuesObj, field) => ({ ...valuesObj, [field.name]: '' }), {});

    const validationSchema = Yup.object().shape(
        fields.reduce(
            (schemaObj, field) => ({
                ...schemaObj,
                [field.name]: field.validation ?? Yup.string(),
            }),
            {}
        )
    );

    const { values, touched, errors, handleChange, handleSubmit, setFieldValue, setValues, isSubmitting } = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            await submitForm(values, idForm);
            await onfileChange(fileData);
            resetForm({ values: initialValues });
            setSubmitting(false);
        },
    });

    const renderField = (field) => {
        const { component, validation, col, ...props } = field;
        if (typeof Components[component] !== 'undefined') {
            return createElement(Components[component], {
                key: field.id,
                onChange: (e) => {
                    if (e.target.type === 'file') {
                        const { files } = e.target;
                        setFieldValue('file', files[0].name);
                        setFileData(files[0]);
                        handleChange(e);

                    } else {
                        if (field.mask === 'currency') {
                            e.target.value = currencyMask(e.target.value);
                        }
                        if (field.mask === 'numberYear') {
                            e.target.value = numberYearMask(e.target.value);
                        }
                        // if (field.type === 'date') {
                        //      e.target.value = new Date(e.target.value).toLocaleDateString('pt-br');
                        // }
                        handleChange(e);
                    }
                    if (idForm === 'root') {
                        onHandleChange(values[field.name], field.name)
                    }
                },
                mask: field.mask ? field.mask : null,
                value: values[field.name],
                disabled: isSubmitting,
                error: touched[field.name] && Boolean(errors[field.name]),
                message: touched[field.name] && errors[field.name],
                ...props,
            });
        }
        return createElement(() => <div>It seems to be a mismatch in your form configuration schema on ID {field.id}.</div>, {
            key: field.id,
        });
    };

    return (
        <Col md={6}>
            <Form onSubmit={handleSubmit} className={classNames(className, 'mt-3')} {...props}>
                <h5 style={{ width: '50%' }}>{title}</h5>
                {fields.map((field, index) => (
                    <React.Fragment key={index}>
                        {renderField(field)}
                    </React.Fragment>
                ))}
            </Form>
        </Col>
    );
};

export default FormBuilder;
